define('modules/page_generator/index',['require','exports','module','base/router','./models/page','./collections/variant_collection','./views/main'],function(require, exports, module){
  "use strict";

  var Router = require("base/router"),
      Page = require("./models/page"),
      VariantCollection = require("./collections/variant_collection"),
      PreviewLayout = require("./views/main");

  module.exports = function(moduleManager){
    var ModuleRouter = Router.extend({
      routes: {
        "preview/:id(/:variantId)": "previewLP",
        "preview": "previewEditor"
      },

      previewLP: function(id, variantId){
        var page = new Page({id: id }),
            variants = new VariantCollection([], {pageId: id}),
            layout = moduleManager.showInstance(PreviewLayout, { model: page, collection: variants, variantId: variantId });
      },

      previewEditor: function(){
        var layout = moduleManager.showInstance(PreviewLayout, {livePreview:true});
      }
    });

    return new ModuleRouter();
  };
});
